export const NoData = ({
  width,
  height,
  message = 'Vi saknar data',
}: {
  width: number;
  height: number;
  message?: string;
}) => {
  return (
    <div
      style={{ width, height }}
      className='flex h-full w-full items-center justify-center'
    >
      <p className='text-muted-foreground'>{message}</p>
    </div>
  );
};
